export default __webpack_public_path__ + "fb665e8e7c57b7c94081258164e7761b.png";